export default __webpack_public_path__ + "static/media/Group_banner.93e3534a.jpg";